import { render } from "./ComponentListCategories.vue?vue&type=template&id=13fc5cc8"
import script from "./ComponentListCategories.vue?vue&type=script&lang=js"
export * from "./ComponentListCategories.vue?vue&type=script&lang=js"

import "./ComponentListCategories.vue?vue&type=style&index=0&id=13fc5cc8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__